export default __webpack_public_path__ + "static/media/Initiate's Gloves of the Celestial Hilt.b816cd69.jpg";